import { render, staticRenderFns } from "./TabArea.vue?vue&type=template&id=b07452d0&scoped=true&"
import script from "./TabArea.vue?vue&type=script&lang=js&"
export * from "./TabArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07452d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b07452d0')) {
      api.createRecord('b07452d0', component.options)
    } else {
      api.reload('b07452d0', component.options)
    }
    module.hot.accept("./TabArea.vue?vue&type=template&id=b07452d0&scoped=true&", function () {
      api.rerender('b07452d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/components/TabArea.vue"
export default component.exports